import React, { useEffect, useState } from 'react';
import { getCookie, clearQueryParams, getCurrentUser, getExpireDate, deleteCookie } from '../../functions/utils'; // Import the utility function
import { fetchMetadata, validate, connect } from '../../functions/exactglobeservice'; // Import the utility function
import CryptoJS from 'crypto-js';
import LoaderComponent from '../utilities/LoaderComponent';
import '../../css/ImportComponent.css';
import '../../css/ExactGlobeComponent.css';
import { useTranslations  } from '../utilities/TranslationContext';
import ExactGlobeLogo from '../../images/ExactGlobeLogo.png';

const ExactGlobeServiceAuth = ({authenticate, setSelectedUser, setConfig}) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [port, setPort] = useState(3443);
  const [serverName, setServerName] = useState("");
  const [databaseName, setDatabaseName] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() =>{
    init();
  },[]);
  useEffect(() =>{
  },[username, password, port, serverName, databaseName, isLoading]);
  
  async function init(){
    var response = await validate(port); 
    
    authenticate(response); 
    setIsLoading(response);
  }

  function handleInputOnChange(event){
    var element = event.target;

    if(element.id == "input-username"){
      setUsername(element.value);
    }
    else if(element.id == "input-password"){
      setPassword(element.value);
    }
    else if(element.id == "input-port"){
      setPort(element.value);
    }
     else if(element.id == "input-servername"){
      setServerName(element.value);
    }
     else if(element.id == "input-databasename"){
      setDatabaseName(element.value);
    }
  }

  async function Connect(){
    var authConfig = {"port": port, "username": username, "password": password, "server_name": serverName, "database_name":databaseName};
    var response = await connect(authConfig);
    if(response){
      setConfig(authConfig);
    }
    authenticate(response);
  }
  return (
    <div className="exactglobe-service-auth"> 
      <div className="exactglobe-authentication-header">
        <div className="exactglobe-authentication-label">
          <p>Service Authentication</p>
        </div>
        <img src={ExactGlobeLogo} className="exactglobe-service-logo" alt="logo" />
      </div>
      {(isLoading) ? 
      <div>
        <LoaderComponent isLoading={isLoading} paddingTop={"20px"}/>
      </div>
      : 
      <div className="exactglobe-service-authform">
        <div className="authform-header">
          <p>Authentication Form</p>
          <div className="vertical-line"></div>
        </div>
        <div className="authform-body">  
          <div className="authform-config authform-port">
            <div className="authform-inputlabel">
              <p>Port:</p>
            </div>
            <div className="authform-inputcontainer">
              <input id="input-port" type="number" value={port} placeholder="3443" onChange={handleInputOnChange}/>
            </div>
          </div>
          <div className={`authform-config authform-service-username`}>
            <div className="authform-inputlabel">
              <p>Username:</p>
            </div>
            <div className="authform-inputcontainer">
              <input id="input-username" value={username} placeholder=""  onChange={handleInputOnChange}/>
            </div>
          </div>
          <div className={`authform-config authform-service-password`}>
            <div className="authform-inputlabel">
              <p>Password:</p>
            </div>
            <div className="authform-inputcontainer">
              <input id="input-password" value={password} placeholder="" type="password" onChange={handleInputOnChange}/>
            </div>
          </div> 
        
          <div className="authform-config authform-servername">
            <div className="authform-inputlabel">
              <p>Server Name:</p>
            </div>
            <div className="authform-inputcontainer">
              <input id="input-servername" value={serverName} onChange={handleInputOnChange}/>
            </div>
          </div>
          <div className="authform-config authform-databasename">
            <div className="authform-inputlabel">
              <p>Database Name:</p>
            </div>
            <div className="authform-inputcontainer">
              <input id="input-databasename" value={databaseName} onChange={handleInputOnChange}/>
            </div>
          </div>
          </div>
        <div className="authform-footer">
          <button className="import-btn hover" onClick={()=>{Connect()}}>Connect</button>
        </div>
      </div>
      }
    </div>
    
  );
}

export default ExactGlobeServiceAuth;
